// extracted by mini-css-extract-plugin
export var orderSummary = "_ra-0";
export var showMoreLessButton = "_ra-1";